import { atom } from 'recoil';
import { DrawerComponentType } from './types';

export const drawerAtom = atom<{
  isOpen: boolean;
  drawerContentType: DrawerComponentType | undefined;
  drawerComponentProps: any;
  onClose?: () => void;
  preventClose?: boolean;
  confirmationModalProps?: {
    title: string;
    message?: string;
    onConfirm: () => void;
    confirmationText?: string;
    secondaryText?: string;
    cancelText?: string;
  };
}>({
  key: 'drawerAtom',
  default: {
    isOpen: false,
    drawerContentType: undefined,
    drawerComponentProps: {},
    onClose: undefined,
    preventClose: false
  }
});
